<div class="payment-select">

  <ng-select style="height: auto" [items]="payments"
             (scroll)="onScroll($event)"
             (scrollToEnd)="onScrollToEnd()"
             bindLabel="header"
             bindValue="id"
             [minTermLength]="2"
             [compareWith]="comparePayments"
             [loading]="loadingPayments"
             [typeahead]="paymentInput$"
             (change)="changeSelectedPayment($event)"
             [(ngModel)]="selectedPayment"
             typeToSearchText="Пожалуйста, введите 2 или более символов"
             i18n-typeToSearchText="@@PaymentAutocompleteTypeToSearchText"
             placeholder="Введите название подпроекта"
             i18n-placeholder="@@PaymentAutocompleteLabel"
  >
    <ng-template ng-header-tmp>
      <small class="form-text text-muted">Загружено {{loadedElements}} из {{totalElements}}</small>
    </ng-template>
  </ng-select>

</div>
